import { NotificationManager } from "react-notifications";
import { cloneDeep } from "lodash";
import { GlobalAuthFetch } from "../../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import i18n from "../../../../../Utils/i18next/i18next";
import { FetchMethodType } from "../../../../../Utils/GlobalVariables/Fetch/MethodsType";

export const onSubmit = async (values, props) => {

  const { updateTableRegistry, loadData, updateSingleRegistry, uuid } =
    props;
  const data = cloneDeep(values);

  if (Boolean(values?.canvasDrawRef?.current) && !values?.signature) {
    data.signature = values?.canvasDrawRef?.current?.getSaveData();
  }

  if(!data.doneCorrectly){
    return {doneCorrectly : i18n.t("global:serviceconfirmmodal.errors.donecorrectly")};
  }

  if(!data.dateAndTimeOfService){
    return {dateAndTimeOfService : i18n.t("global:serviceconfirmmodal.errors.dateAndTimeOfService")};
  }

  if(data?.signature && JSON.parse(data?.signature)?.lines?.length <= 0){
    return {signature: i18n.t("global:serviceconfirmmodal.errors.signature")}
  }

  delete data?.canvasDrawRef

  let payload;

  const res = await GlobalAuthFetch({
    path: `/service/serviceConfirm/${uuid}`,
    method: FetchMethodType.patch,
    data: data,
  });

  payload = res.payload;

  if (payload?.status >= 300 || !payload?.status) {
    props.setErrorHeader(0, true);

    return;
  }

  props.setErrorHeader(0, false);

  //Succes nofify
  loadData();
  NotificationManager.success(i18n.t("global:success"));
  if (updateSingleRegistry) updateSingleRegistry();
  if (updateTableRegistry) updateTableRegistry();
  if(Boolean(payload?.status) && payload?.status < 300)
    props.handleHide();
};

export const onValidate = (values, props) => {
  const errorsStep0 = {};

  if (
    !props.steps[0]?.error &&
    props.isSubmit &&
    Object.keys(errorsStep0).length > 0
  ) {
    props.setErrorHeader(0, true);
  }
  if (
    !!props.steps[0]?.error &&
    props.isSubmit &&
    Object.keys(errorsStep0).length <= 0
  ) {
    props.setErrorHeader(0, false);
  }

  return { ...errorsStep0 };
};
